export default (object, values, years) => {
    years.map((year, i) => {
        if (object?.[year]) object[year] += +values[i];
        else object = { ...object, [year]: +values[i] };
    });
    return object;
};
